<template>
  <div class="center" :class="{ 'center-light': theme === 'light' }">
    <!-- 主界面信息展示区 -->
    <div class="center-main">
      <div class="center-main-title">
        <div v-if="showProjectNameDirect" class="title-box">
          【{{ projectInfo.projectCode }}】{{ projectInfo.projectName }}
          {{ projectInfo.projectId }}
        </div>
        <el-popover
          v-else
          placement="bottom"
          trigger="hover"
          width="500"
          :content="projectInfo.projectName"
        >
          <div slot="reference" class="text-ellipsis center-main-title-content">
            【{{ projectInfo.projectCode }}】{{ projectInfo.projectName }}
          </div>
        </el-popover>

        <!-- 解密倒计时 -->
        <div v-if="showDecryptCountDown" class="decrypt-count-down">
          {{ bidFileTypeLabel }}文件解密剩余时间：
          <span style="color: #27D8FE">{{ leftTime }}</span>
        </div>

        <div v-if="isAudioShow" class="play-box">
          <div class="play-btn" @click="restartSpeak">
            <i class="el-icon-refresh-right icon"></i>
            重播
          </div>
          <!-- 开始唱标 -->
          <div
            v-show="playStatus === 'pending'"
            class="play-btn"
            @click="startSpeak('start')"
          >
            <i class="el-icon-video-play icon"></i>
            唱标
          </div>
          <div
            v-show="playStatus === 'start'"
            class="play-btn"
            @click="pauseSpeak('pause')"
          >
            <i class="el-icon-video-pause icon"></i>
            暂停
          </div>
          <!-- 恢复唱标 -->
          <div
            v-show="playStatus === 'pause'"
            class="play-btn"
            @click="resumeSpeak('start')"
          >
            <i class="el-icon-video-play icon"></i>
            唱标
          </div>
        </div>
      </div>

      <div class="center-main-content flex flex-col">
        <el-scrollbar class="flex-1 scrollbar-y-hidden" style="width: 100%">
          <div class="p-h-24">
            <slot name="body"></slot>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 底部操作区 -->
    <div v-if="showFooter" class="center-operation">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import {
  bidFileTypeDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'
import DateUtils from '@/utils/date'
import { addMinutes } from 'date-fns'
import { asyncInterval } from '@/utils/utils'
import { isFunction } from 'lodash'

export default {
  name: 'BidOpenCenter',

  components: {},

  props: {
    theme: {
      validator: function(value) {
        return ['dark', 'light'].indexOf(value) !== -1
      },
      default: 'dark'
    },

    projectId: {
      type: [Number, String],
      default: 0
    },

    bidFileType: {
      type: Number,
      default: bidFileTypeDict.BUSINESS.value
    },

    projectInfo: {
      type: Object,
      default: () => {}
    },

    leftTimeConfig: {
      type: Object,
      default: () => {}
    },

    showFooter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      fileurl: '',
      msg:
        '这个被NASA称为“门户(Gateway)”的空间站可以为人类的太空探索开辟出一系列巨大的可能性。',
      voiceObj: '',
      speakMsg: '',
      playStatus: 'pending',

      // 距离开标的剩余时间相关变量
      leftTimeUtil: new DateUtils(),
      leftTime: '',
      loopTimeControl: null
    }
  },

  computed: {
    ...mapState('systemTime', ['systemMillisecond']),
    ...mapState('reviewHall', ['isAudioShow', 'chantPlay']),
    ...mapGetters('reviewHall', ['playContent']),
    ...mapState('system', ['isIE']),
    // 直接显示项目名称
    showProjectNameDirect() {
      return this.projectInfo.projectName?.length <= 10
    },
    src() {
      return ''
    },
    // 是否显示解密倒计时
    showDecryptCountDown() {
      return !!this.leftTime
    },

    reviewModel() {
      return this.projectInfo.reviewModel
    },

    bidFileTypeLabel() {
      return bidFileTypeDict.translate(this.bidFileType)?.label
    }
  },

  watch: {
    chantPlay: {
      handler: function(val) {
        if (this.chantPlay) {
          // this.startSpeak('start')
          this.restartSpeak()
          this.$store.dispatch('reviewHall/changeChantPlay', false)
        }
      },
      immediate: true,
      deep: true
    },

    projectInfo: {
      handler(val) {
        this.handleQuoteDecryptCountDown()
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    if (!this.isIE) {
      this.creatSpeak()
    } else {
      this.$message.warning('当前浏览器不支持唱标功能，推荐使用360急速浏览器')
    }
  },

  beforeDestroy() {
    window.speechSynthesis.cancel()
    this.leftTimeUtil.stopCountDown()
    if (isFunction(this.loopTimeControl?.stop)) {
      this.loopTimeControl.stop()
    }
  },

  methods: {
    async creatSpeak() {
      if (!this.isAudioShow) {
        return
      }
      window.speechSynthesis.cancel()
      const playContentInfo = await this.$store.dispatch(
        'reviewHall/changeChantPlayContent',
        { projectId: this.projectId, bidFileType: this.bidFileType }
      )
      const playContentNew = playContentInfo || this.playContent
      this.speakMsg = new window.SpeechSynthesisUtterance(playContentNew)
      this.speakMsg.rate = 1
      this.speakMsg.pitch = 1.5
      this.speakMsg.lang = 'zh-CN'
      this.speakMsg.onend = event => {
        this.playStatus = 'pending'
      }
    },

    // 开始播放语音
    async restartSpeak() {
      if (!this.isAudioShow) {
        return
      }
      if (this.isIE) {
        this.$message.warning('当前浏览器不支持唱标功能，推荐使用360急速浏览器')
      }
      window.speechSynthesis.cancel()
      const playContentInfo = await this.$store.dispatch(
        'reviewHall/changeChantPlayContent',
        { projectId: this.projectId, bidFileType: this.bidFileType }
      )
      const playContentNew = playContentInfo
      this.speakMsg = new window.SpeechSynthesisUtterance(playContentNew)
      this.speakMsg.rate = 1
      this.speakMsg.pitch = 1.5
      this.speakMsg.lang = 'zh-CN'
      this.speakMsg.onend = event => {
        this.playStatus = 'pending'
      }
      // this.startSpeak('start')
      this.playStatus = 'start'
      window.speechSynthesis.speak(this.speakMsg)
    },

    // 开始播放语音
    startSpeak(status) {
      if (this.isIE) {
        this.$message.warning('当前浏览器不支持唱标功能，推荐使用360急速浏览器')
      }
      // this.playStatus = status
      // window.speechSynthesis.speak(this.speakMsg)
      this.restartSpeak()
    },

    // 暂停
    pauseSpeak(status) {
      this.playStatus = status
      window.speechSynthesis.pause()
    },

    // 恢复播放
    resumeSpeak(status) {
      this.playStatus = status
      window.speechSynthesis.resume()
    },

    // 解密倒计时
    decryptCountDown(endTime) {
      return new Promise(resolve => {
        this.$store.dispatch('systemTime/getSystemTime').then(() => {
          const startTime = new Date(this.systemMillisecond)
          this.leftTimeUtil.countTimeDown(startTime, endTime, ms => {
            const leftTimeMillisecond = ms < 0 ? 0 : ms
            const { hours, minutes, seconds } = DateUtils.formatDuring(
              leftTimeMillisecond
            )
            const addZero = num => (num < 10 ? '0' + num : num)
            this.leftTime = `${addZero(hours)}:${addZero(minutes)}:${addZero(
              seconds
            )}`
            if (leftTimeMillisecond === 0) {
              this.leftTime = '已截止'
            }
          })
        })
      })
    },

    /**
     * 报价文件解密倒计时
     */
    handleQuoteDecryptCountDown() {
      // 仅双信封有报价解密倒计时
      if (this.reviewModel === reviewModelDict.DEFAULT.value) return
      // 如果已开始唱标，则停止倒计时
      if (this.leftTimeConfig?.markOpened) {
        this.leftTime = '已截止'
        return
      }

      if (this.leftTimeConfig?.startTime) {
        this.loopTimeControl = asyncInterval(
          () => this.decryptCountDown(this.leftTimeConfig?.endTime),
          3000
        )
        this.loopTimeControl.start().then(() => {
          if (this.leftTime === '已截止') {
            this.loopTimeControl.stop()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  width: 100%;
  flex: 1;
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  // 浅色主体的颜色修改
  &.center-light {
    .center-main {
      .center-main-title {
        color: $text-color;

        .play-box {
          color: $primary-color;
        }
      }

      ::v-deep .el-table {
        tr,
        th,
        td {
          color: $text-color;
          border-bottom-color: $border-color;
        }
        th {
          background-color: rgba(24, 144, 255, 0.12);
        }
      }
    }
  }

  .center-main {
    position: relative;
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(24, 144, 255, 0.4);

    &:before {
      content: '';
      position: absolute;
      bottom: -2px;
      left: -2px;
      width: 28px;
      height: 28px;
      border: 4px solid #00a2ff;
      border-top-color: transparent;
      border-right-color: transparent;
    }
    &:after {
      content: '';
      position: absolute;
      bottom: -2px;
      right: -2px;
      width: 28px;
      height: 28px;
      border: 4px solid #00a2ff;
      border-top-color: transparent;
      border-left-color: transparent;
    }

    .center-main-title {
      width: 100%;
      height: 56px;
      font-size: 24px;
      @include text-bold;
      color: #fdffff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      overflow: hidden;
      background-color: rgba(24, 144, 255, 0.12);

      .title-box {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .play-box {
        width: 200px;
        display: flex;
        color: #27d8fe;
        justify-content: flex-end;
        .play-btn {
          font-size: 16px;
          margin-left: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-top: 2px;
          .icon {
            font-size: 24px;
            margin-right: 6px;
            margin-top: -2px;
          }
        }
      }
      span {
        width: 100%;
        display: inline-block;
      }

      .center-main-title-content {
        width: 100%;
      }
    }

    .center-main-content {
      width: 100%;
      margin-top: 43px;
      flex: 1;
      overflow: hidden;
    }
  }

  ::v-deep .el-table {
    background: transparent;
    color: #feffff;
    border: none;

    &::before,
    .el-table--group::after,
    .el-table--border::after {
      background-color: #d7cdd6;
    }

    &::before {
      height: 0px;
    }

    th {
      background: #072448;
      color: #feffff;
      border: none;
    }

    tr {
      background: transparent;
      color: #feffff;
    }

    .el-table__body {
      tr:hover > td {
        background: transparent;
      }
    }

    th.is-leaf,
    td {
      border-bottom: 1px solid rgba(215, 205, 214, 0.1);
    }
  }

  // 深色模式下修改分页组件样式
  &:not(.center-light) {
    ::v-deep .pagination-container {
      background: transparent;

      .el-pagination__total {
        color: #feffff;
      }

      .el-input__inner {
        background: transparent;
        color: #feffff;
      }

      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .el-pager li {
        background: transparent;
        color: #feffff;
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        color: #27d8fe;
        border-color: #27d8fe;
      }

      .el-pagination__jump {
        color: #feffff;
      }
    }
  }
}

.center-operation {
  width: 100%;
  height: 64px;
  line-height: 64px;
  border: 1px solid rgba(24, 144, 255, 0.4);
  box-sizing: border-box;
  padding: 0 24px;
  margin-top: 16px;
}

.decrypt-count-down {
  white-space: nowrap;
}
</style>
